import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepBasicInfo from './steps/StepBasicInfo';
import StepBenefitMechanic from './steps/StepBenefitMechanic';
import StepEligibilityConditions from './steps/StepEligibilityConditions';
import StepProducts from './steps/StepProducts';
import StepReviewAndPublish from './steps/StepReviewAndPublish';

const IconCheck = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
  <path d="M14.2498 2.96875H13.1576C13.0045 2.96875 12.8591 3.03906 12.7654 3.15937L6.3232 11.3203L3.23414 7.40625C3.18741 7.34692 3.12785 7.29895 3.05992 7.26593C2.992 7.23292 2.91748 7.21572 2.84195 7.21562H1.74976C1.64508 7.21562 1.58726 7.33594 1.65133 7.41719L5.93102 12.8391C6.13102 13.0922 6.51539 13.0922 6.71695 12.8391L14.3482 3.16875C14.4123 3.08906 14.3545 2.96875 14.2498 2.96875Z" fill="black" fill-opacity="0.88"/>
</svg>
)

const steps = [
  { path: 'basic-info', label: 'Basic Info', component: StepBasicInfo },
  { path: 'benefit-mechanic', label: 'Benefit & Mechanic', component: StepBenefitMechanic },
  { path: 'eligibility-conditions', label: 'Eligibility Conditions', component: StepEligibilityConditions },
  { path: 'products', label: 'Products (Include/Exclude)', component: StepProducts },
  { path: 'review-and-publish', label: 'Review & Publish', component: StepReviewAndPublish },
];

const createRulesRoute = '/app/membership-rules/new/create-rules';
const initialFormData = {
  ruleName: '',
  storefront: '',
  ruleDescription: '',
  giftEnabled: true,
  minCartValue: '',
  giftSkus: [],
  giftsPerOrder: '2',
  discountEnabled: true,
  discountType: 'percentage',
  discountValue: '',
  ruleType: 'BAU',
  memberType: 'Member',
  activeStartDate: '',
  activeEndDate: '',
  attributeCondition: 'online_is_anniversary > 1',
  redemptionLimit: '2',
  priority: '2',
  listType: 'Included',
  skuSource: 'Custom SKUs',
  includedSkus: '',
};

const MembershipRuleWizard = () => {
  const navigate = useNavigate();
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [maxUnlockedStep, setMaxUnlockedStep] = useState(0);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (window.location.pathname.endsWith('/new')) {
      navigate(createRulesRoute, { replace: true });
    }
  }, [navigate]);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const currentStepIndex = Math.min(Math.max(activeStepIndex, 0), steps.length - 1);
  const currentStep = steps[currentStepIndex];
  const CurrentStepComponent = currentStep.component;

  const goToStep = (index) => {
    const step = steps[index];
    if (!step) return;
    if (index > maxUnlockedStep) return;
    setActiveStepIndex(index);
  };

  const moveToNext = () => {
    const nextIndex = currentStepIndex + 1;
    const nextStep = steps[nextIndex];
    if (!nextStep) return;
    setMaxUnlockedStep((prev) => Math.max(prev, nextIndex));
    setActiveStepIndex(nextIndex);
  };

  const moveToPrevious = () => {
    const prevIndex = currentStepIndex - 1;
    if (prevIndex < 0) {
      navigate('/app/membership-rules');
      return;
    }
    setActiveStepIndex(prevIndex);
  };

  return (
    <div className='MembershipDashboard'>
      <div className='rule-nav'>
        <div className='rule-left-nav' >
          <button
            type="button"
            onClick={() => navigate('/app/membership-rules')}
            className='btn-s w-164'
          >
            ← Back to All Rules
          </button>

          {steps.map((step, index) => {
            const isDone = index < maxUnlockedStep;
            const isActive = index === currentStepIndex;
            return (
              <button
                key={step.path}
                type="button"
                onClick={() => goToStep(index)}
                className={`rule-left-nav-btn ${isActive ? 'rule-btn-active' : ''}`}
                style={{
                  cursor: index <= maxUnlockedStep ? 'pointer' : 'not-allowed',
                  opacity: index <= maxUnlockedStep ? 1 : 0.5,
                }}
              >
                {isDone && 
                    <span className='Icon-check'>
                        <IconCheck />
                    </span>
                }
                <span style={{ fontSize: 14 }}>{step.label}</span>
              </button>
            );
          })}
        </div>

        <div className='rule-right-content'>
          <CurrentStepComponent
            onNext={moveToNext}
            onBack={moveToPrevious}
            formData={formData}
            updateField={updateField}
          />
        </div>
      </div>
    </div>
  );
};

export default MembershipRuleWizard;
